/**
 * As a common decision taken with Equancy,
 * 'pageInfo' regroups the tags (built on server-side) related to the page,
 * while 'eventInfo' regroups temporary tags fired by events (from client-side).
 * @type {Object}
 */
export const SECTIONS_PATHS = {
  PAGE_INFO: 'pageInfo',
  EVENT_INFO: 'eventInfo'
}

/**
 * Set path for loading time and events.
 * @type {Object}
 */
export const TAG_PATHS = {
  LOAD_TIME: `${SECTIONS_PATHS.PAGE_INFO}.loadingtime`,
  EVENT_NAMES: `${SECTIONS_PATHS.EVENT_INFO}.events`
}



// WEBPACK FOOTER //
// ./lib/modules/dgad-analytics/src/adobe/lib/datalayer-paths.js